import React from 'react';

const SectionDivider = ({ width = '50%', extraPaddingClass }) => {
    let cssClass = `mt-1 mb-3 ${extraPaddingClass}`;
    return <hr className={cssClass} style={{ width: width }} />
}

export default SectionDivider;